import React from "react";
import { cn } from "../../@/lib/utils";

const DashboardChartContainer = ({
  type,
  position,
  children,
}: {
  type: number;
  position: number;
  children: React.ReactNode;
}) => {
  return (
    <>
      <div
        className={cn(
          type === 2
            ? position === 5
              ? "lg:col-span-2"
              : "col-span-1"
            : type === 1
              ? position === 1
                ? "lg:col-span-2"
                : "col-span-1"
              : "", "h-[40vh] lg:h-[42vh] xl-2xl:h-[42vh] 2xl:h-[43vh]",
          "w-full rounded-md p-1"
        )}
      >
        <div className="bg-black rounded-md w-full h-full">{children}</div>
      </div>
    </>
  );
};

export default DashboardChartContainer;